var _style, _defs, _defs2, _path, _path2, _path3, _defs3, _defs4, _defs5, _defs6, _g, _polygon, _polygon2, _rect, _defs7, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlfaIntes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 850.39 243",
    style: {
      enableBackground: "new 0 0 850.39 243"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.6;}\n\t.st1{clip-path:url(#SVGID_00000119114224473089387370000001389465363460260243_);fill:#00A975;}\n\t.st2{clip-path:url(#SVGID_00000177466254447166814090000009011391706887473833_);fill:#00A975;}\n\t.st3{fill:#00A975;}\n\t.st4{clip-path:url(#SVGID_00000177472900090722157830000001668188753353734846_);fill:#00A975;}\n\t.st5{clip-path:url(#SVGID_00000010989864397646528140000004911804024403575189_);fill:#00A975;}\n\t.st6{clip-path:url(#SVGID_00000098179744617053365930000013285937128102638515_);fill:#00A975;}\n\t.st7{clip-path:url(#SVGID_00000034048603387605440280000018267261047610491048_);fill:#00A975;}\n\t.st8{clip-path:url(#SVGID_00000059271991259025415380000016185855503906972820_);fill:#00A975;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 642.9,
    y: 165.33,
    width: 34.54,
    height: 34.54
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000091698842879029309740000005185207181331627936_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 645.01,
    y: 167.44,
    transform: "matrix(0.9962 -0.0869 0.0869 0.9962 -13.3672 58.0428)",
    style: {
      clipPath: "url(#SVGID_00000091698842879029309740000005185207181331627936_)",
      fill: "#00A975"
    },
    width: 30.32,
    height: 30.32
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000019650587242103794400000000026713845017102502_",
    x: 711.37,
    y: 107.93,
    width: 64.81,
    height: 61.49
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005263453255170583090000014653905360122976441_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000019650587242103794400000000026713845017102502_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000005263453255170583090000014653905360122976441_)",
      fill: "#00A975"
    },
    points: " 732.06,110.24 713.93,145.78 756.61,167.57 767.69,145.87  "
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M184.96,131.06c0,2.66-1.31,3.98-3.93,3.98h-35.86c-8.19,0-14.59-0.74-19.19-2.21 c-7.09-2.45-10.63-7.1-10.63-13.96V77.62c0-2.62,1.31-3.93,3.93-3.93c2.51,0,4.13,0.1,4.83,0.3c1.61,0.47,2.42,1.68,2.42,3.63 v41.25c0,3.19,2.59,5.29,7.76,6.3c1.64,0.43,5.47,0.65,11.48,0.65h35.26C183.66,125.83,184.96,127.57,184.96,131.06"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M262.14,104.62c0,3.09-1.39,4.63-4.18,4.63h-53.54v21.81c0,2.65-1.31,3.98-3.93,3.98 c-2.79,0-4.4-0.12-4.84-0.35c-1.61-0.5-2.42-1.71-2.42-3.63V88c0-4.9,3.15-8.66,9.47-11.28c4.84-2.01,10.14-3.02,15.92-3.02h8.36 c2.65,0,3.98,1.71,3.98,5.14c0,2.65-1.33,3.98-3.98,3.98c-15.05,0-22.57,1.87-22.57,5.6v11.63h53.54 C260.74,100.04,262.14,101.57,262.14,104.62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M308.58,109.66l-16.97-25.03l-17.07,25.03H308.58z M335.73,130.86c0,1.54-0.52,2.84-1.56,3.88 c-1.04,1.04-2.34,1.56-3.88,1.56c-2.15,0-3.9-1.01-5.24-3.02l-9.93-14.41h-47.14l-9.93,14.41c-1.07,1.58-2.23,2.36-3.47,2.36 c-1.24,0-2.43-0.4-3.58-1.21c-1.27-0.87-1.91-1.89-1.91-3.07c0-0.37,0.1-0.71,0.3-1.01l35.36-54.05c1.44-2.22,3.93-3.32,7.45-3.32 c2.62,0,4.37,0.74,5.24,2.22l0.23,0.43c0.08,0.18,0.21,0.41,0.38,0.68l37.48,53.03C335.66,129.59,335.73,130.09,335.73,130.86"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000152235903226069487840000014721321366946549136_",
    x: 374.59,
    y: 72.84,
    width: 12.88,
    height: 63.05
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000114047434791701148170000018150539058511915405_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152235903226069487840000014721321366946549136_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000114047434791701148170000018150539058511915405_)",
      fill: "#00A975"
    },
    d: "M386.63,131.06 c0,2.66-1.31,3.98-3.93,3.98c-1.14,0-2.12-0.02-2.92-0.07c-0.81-0.05-1.45-0.11-1.91-0.18c-1.61-0.5-2.42-1.75-2.42-3.73V77.62 c0-1.98,0.79-3.2,2.37-3.68c0.37-0.07,0.96-0.13,1.77-0.18c0.8-0.05,1.85-0.08,3.12-0.08c2.62,0,3.93,1.31,3.93,3.93V131.06z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000110429345982916305610000011652053282428803263_",
    x: 396.46,
    y: 72.4,
    width: 77.65,
    height: 63.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181779976089277257090000008070417594370798981_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000110429345982916305610000011652053282428803263_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000181779976089277257090000008070417594370798981_)",
      fill: "#00A975"
    },
    d: "M473.26,128.45 c0,4.67-2.05,7-6.14,7c-1.88,0-4.01-0.99-6.4-2.97L408.5,88.1v42.96c0,1.98-0.81,3.22-2.42,3.73c-0.47,0.07-1.11,0.12-1.91,0.18 c-0.81,0.05-1.78,0.08-2.92,0.08c-2.62,0-3.93-1.32-3.93-3.98V79.89c0-4.43,1.92-6.65,5.74-6.65c2.42,0,4.91,1.07,7.46,3.22 l51.57,43.87V77.63c0-1.95,0.8-3.17,2.41-3.68c0.46-0.07,1.1-0.13,1.9-0.18c0.8-0.05,1.77-0.08,2.91-0.08 c2.63,0,3.95,1.31,3.95,3.93V128.45z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000032640209297266293160000011312932747513831048_",
    x: 479.83,
    y: 72.85,
    width: 70.24,
    height: 63.05
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147221372033743287600000008265735510871976353_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000032640209297266293160000011312932747513831048_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000147221372033743287600000008265735510871976353_)",
      fill: "#00A975"
    },
    d: "M549.22,78.83 c0,2.66-1.31,3.98-3.93,3.98h-24.83v48.25c0,2.66-1.3,3.98-3.89,3.98c-2.63,0-4.27-0.11-4.91-0.31 c-1.58-0.47-2.38-1.69-2.38-3.68V82.81h-24.63c-2.65,0-3.98-1.32-3.98-3.98c0-1.81,0.2-3.05,0.61-3.72 c0.53-0.94,1.66-1.41,3.37-1.41h60.64C547.91,73.7,549.22,75.41,549.22,78.83"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000145045883092824072150000004317829435688777377_",
    x: 553.82,
    y: 72.84,
    width: 70.9,
    height: 63.05
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142885713538451612100000013150773024136331416_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000145045883092824072150000004317829435688777377_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000142885713538451612100000013150773024136331416_)",
      fill: "#00A975"
    },
    d: "M623.86,104.37 c0,3.26-1.39,4.89-4.18,4.89h-53.83v10.07c0,4.33,4.78,6.5,14.35,6.5h39.48c2.62,0,3.93,1.33,3.93,3.98 c0,3.49-1.31,5.24-3.93,5.24H579.7c-5.85,0-11.2-1.04-16.07-3.12c-5.98-2.72-8.97-6.78-8.97-12.19V89.31 c0-2.92,0.99-5.57,2.97-7.96c4.3-5.1,11.97-7.66,23.01-7.66h10.93c2.59,0,3.88,1.72,3.88,5.14c0,2.66-1.29,3.98-3.88,3.98h-3.17 c-0.37,0-0.57-0.01-0.61-0.05c-0.84-0.03-1.56-0.06-2.17-0.08c-0.6-0.02-1.11-0.02-1.51-0.02c-12.25,0-18.38,2.21-18.38,6.64 v10.73h53.98C622.49,100.04,623.86,101.48,623.86,104.37"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M700.18,119.83c0,3.29-0.52,5.86-1.56,7.71c-2.79,5-11.21,7.5-25.29,7.5H634.6c-2.59,0-3.88-1.33-3.88-3.98 c0-1.81,0.2-3.07,0.61-3.78c0.57-0.97,1.66-1.46,3.27-1.46h38.73c10.44,0,15.67-1.93,15.67-5.79v-5.29 c0-3.76-5.06-5.81-15.16-6.15l-18.58-0.6c-0.88-0.03-2.11-0.09-3.7-0.18c-1.6-0.08-3.55-0.21-5.87-0.38 c-4.03-0.47-7.49-1.8-10.38-3.98c-3.16-2.42-4.73-5.59-4.73-9.52v-4.63c0-7.15,3.96-11.87,11.89-14.15 c3.79-0.97,10.75-1.46,20.85-1.46c2.62,0,3.93,1.72,3.93,5.14c0,1.98-0.79,3.23-2.37,3.73c-0.24,0.13-1.83,0.2-4.78,0.2 c-12.22,0-18.34,2.15-18.34,6.45v4.28c0,2.65,2.28,4.38,6.85,5.19c0.87,0.17,2.14,0.3,3.8,0.38c1.66,0.09,3.71,0.13,6.12,0.13 h14.96c7.15,0,12.79,0.92,16.92,2.77c6.51,2.69,9.77,6.82,9.77,12.39V119.83z"
  }))))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "630.55,173.55 627.45,195.07 605.95,191.96 609.04,170.46  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "828.04,103.27 776.56,51.79 725.09,103.27 732.06,110.24 735.71,103.09 778.4,124.88 767.69,145.87  776.56,154.75  "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 577.23,
    y: 196.2,
    transform: "matrix(0.3026 -0.9531 0.9531 0.3026 213.5865 699.678)",
    className: "st3",
    width: 15.37,
    height: 15.37
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000109026032594936582630000002687827527923164328_",
    y: -79.94,
    width: 850.39,
    height: 425.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137095099195181980480000012138102725938926988_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000109026032594936582630000002687827527923164328_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000137095099195181980480000012138102725938926988_)",
      fill: "#00A975"
    },
    d: "M82.15,109.66 L65.18,84.63l-17.07,25.03H82.15z M109.3,130.86c0,1.54-0.52,2.84-1.56,3.88c-1.04,1.04-2.34,1.56-3.88,1.56 c-2.15,0-3.9-1.01-5.24-3.02l-9.93-14.41H41.56l-9.93,14.41c-1.07,1.58-2.23,2.36-3.47,2.36c-1.24,0-2.43-0.4-3.58-1.21 c-1.28-0.87-1.91-1.89-1.91-3.07c0-0.37,0.1-0.71,0.3-1.01l35.36-54.05c1.44-2.22,3.92-3.32,7.45-3.32c2.62,0,4.37,0.74,5.24,2.22 l0.23,0.43c0.08,0.18,0.21,0.41,0.38,0.68l37.48,53.03C109.23,129.59,109.3,130.09,109.3,130.86"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 695.71,
    y: 148.14,
    transform: "matrix(0.0786 -0.9969 0.9969 0.0786 492.0339 863.7479)",
    className: "st3",
    width: 35.13,
    height: 35.12
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlfaIntes);
export default __webpack_public_path__ + "static/media/alfa_intes.f9634d786ec52fdc7934ca92743cf971.svg";
export { ForwardRef as ReactComponent };